export function getWishListForWish(wishId: number, wishLists?: IWishListDto[]) {
  return wishLists?.find((wl) => wl.wishes.find((w) => w.id === wishId))
}

export function getBackgroundPosition(imageFocus?: EImageFocus) {
  if (!imageFocus) {
    return "center"
  }
  switch (imageFocus) {
    case "contain":
      return "center"
    case "coverCenter":
      return "center"
    case "coverTop":
      return "top"
    case "coverLeft":
      return "left"
    case "coverRight":
      return "right"
    case "coverBottom":
      return "bottom"
  }
  return "center"
}
